import React from "react";
import { Link } from "react-router-dom";

const ClientsNavbar = () => {
  return (
    <>
      <li className="nav-item">
        <a
          className="nav-link menu-link"
          href="#dmexecutive"
          data-bs-toggle="collapse"
          role="button"
          aria-expanded="false"
          aria-controls="dmexecutive"
        >
          <i className="ri-rocket-line"></i>
          <span data-key="t-clients">Influencer</span>
        </a>
        <div className="collapse menu-dropdown" id="dmexecutive">
          <ul className="nav nav-sm flex-column">
            {/* <li className="nav-item">
              <Link
                to="/active-influencer"
                className="nav-link"
                data-key="t-analytics"
              >
                Active Influencer{" "}
              </Link>
            </li> */}
            {/* <li className="nav-item">
              <Link
                to="/assigned-influencer"
                className="nav-link"
                data-key="t-ecommerce"
              >
                Assigned Influencer
              </Link>
            </li> */}
            {/* <li className="nav-item">
              <Link
                to="/pending-influencer"
                className="nav-link"
                data-key="t-analytics"
              >
                Pending Influencer{" "}
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/inactive-influencer"
                className="nav-link"
                data-key="t-crm"
              >
                Inactive Influencer{" "}
              </Link>
            </li> */}
            <li className="nav-item">
              <Link
                to="/all-influencer"
                className="nav-link"
                data-key="t-ecommerce"
              >
                All Influencer
              </Link>
            </li>
          </ul>
        </div>
      </li>
      <li className="nav-item">
        <Link className="nav-link menu-link" to="/influencer-register">
          <i className="ri-dashboard-2-line"></i>
          <span data-key="t-dashboard">Influencer Register</span>
        </Link>
      </li>

      <li className="nav-item">
        <a
          className="nav-link menu-link active"
          href="#sidebarDashboards"
          data-bs-toggle="collapse"
          role="button"
          aria-expanded="false"
          aria-controls="sidebarDashboards"
        >
          <i className="ri-rocket-line"></i>
          <span data-key="t-influencers">User Register</span>
        </a>
        <div className="collapse menu-dropdown" id="sidebarDashboards">
          <ul className="nav nav-sm flex-column">
            <li className="nav-item">
              <Link
                to="/registered-user-list"
                className="nav-link"
                data-key="t-analytics"
              >
                User List{" "}
              </Link>
            </li>
          </ul>
        </div>
      </li>
    </>
  );
};

export default ClientsNavbar;
